// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__32V3J","list":"BalanceDue_list__2lvVg","listRow":"BalanceDue_listRow__3GleT","total":"BalanceDue_total__2vS1I"};